export function useDashboardData(authToken, userStores) {
  return {
    stores: userStores || [],
    loading: false,
  }
}
